import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function footer() {
    const footer = document.querySelector('#site-footer');

    if (!footer) {
        return;
    }

    const footerTl = gsap.timeline({
        scrollTrigger: {
            trigger: footer,
            start: 'top bottom'
        }
    });

    footerTl.to('.footer-bg-shape', {
        scale: 1,
        //y: 0,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 2,
        stagger: 0.3
    });
    footerTl.to('.footer-bg-shape', {
        x: () => gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        duration: () => gsap.utils.random(2, 3),
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        stagger: {
            amount: 0.5,
            from: 'random'
        }
    });
}
